/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { notificationService } from './services';
// #endregion Local Imports

const pathname = '/noti';

export const NotificationApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await notificationService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  getCount: async (option: any) => {
    let url = `${pathname}/count`;
    const query = serialize(option);
    url += query;
    try {
      const response = await notificationService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await notificationService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any) => {
    const url = `${pathname}/${id}/status`;
    try {
      const response = await notificationService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await notificationService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
